import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

const SERVICES = [
  {
    id: "plumbing",
    title: "Plumbing",
    badge: "Urgent Requests Welcome",
    description: "Leak detection, pipe repair, water heaters, fixtures, and responsive service.",
    span: "md:col-span-7 md:row-span-2",
    img: "https://images.unsplash.com/photo-1676210134190-3f2c0d5cf58d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA6MjJ8MHwxfHNlYXJjaHwzfHxwbHVtYmluZyUyMGVsZWN0cmljaWFuJTIwcmVwYWlyJTIwaG9tZSUyMG1haW50ZW5hbmNlJTIwd29ya2VyJTIwdHJhZGVzcGVyc29uJTIwcHJvZmVzc2lvbmFsfGVufDB8fHx8MTc5MTg0NTE5N3ww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "electrical",
    title: "Electrical",
    badge: "Qualified Professionals",
    description: "Panel work, lighting, outlets, EV chargers, and circuit diagnostics.",
    span: "md:col-span-5",
    img: "https://images.unsplash.com/photo-1660330589693-99889d60181e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA6MjJ8MHwxfHNlYXJjaHwyfHxwbHVtYmluZyUyMGVsZWN0cmljaWFuJTIwcmVwYWlyJTIwaG9tZSUyMG1haW50ZW5hbmNlJTIwd29ya2VyJTIwdHJhZGVzcGVyc29uJTIwcHJvZmVzc2lvbmFsfGVufDB8fHx8MTc5MTg0NTE5N3ww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "hvac",
    title: "HVAC",
    badge: "Heating & Cooling",
    description: "AC and furnace service, filter programs, and seasonal tune-ups.",
    span: "md:col-span-5",
    img: "https://images.unsplash.com/photo-1642749776312-aa42ce20c9f5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHxIVkFDJTIwdGVjaG5pY2lhbiUyMEFDJTIwbWFpbnRlbmFuY2UlMjByZXBhaXJ8ZW58MHx8fHwxNzkyMDE0OTA4fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "carpentry",
    title: "Carpentry",
    badge: "Master Craftsmanship",
    description: "Framing, cabinetry, trim, doors, and structural wood repair.",
    span: "md:col-span-4",
    img: "https://images.unsplash.com/photo-1608613304899-ea8098577e38?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA6OTV8MHwxfHNlYXJjaHwzfHxjYXJwZW50ZXIlMjB3b29kd29ya2luZyUyMGNhYmluZXRyeSUyMGNvbnN0cnVjdGlvbnxlbnwwfHx8fDE3OTIwMTQ5MDh8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "painting",
    title: "Painting",
    badge: "Low-VOC Premium Finishes",
    description: "Interior and exterior painting, coatings, and cabinet refinishing.",
    span: "md:col-span-4",
    img: "https://images.unsplash.com/photo-1717281234297-3def5ae3eee1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHxwYWludGVyJTIwd2FsbCUyMHBhaW50aW5nJTIwaG9tZSUyMHJlbm92YXRpb258ZW58MHx8fHwxNzkxODQ1MjA0fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "cleaning",
    title: "Cleaning",
    badge: "Deep Clean Detail",
    description: "Deep cleans, trash bin cleaning, pressure washing, and move-in/out turnover prep.",
    span: "md:col-span-4",
    img: "https://images.unsplash.com/photo-1644338785159-6c0a9dd037b2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwzfHxjbGVhbmluZyUyMHdvcmtlciUyMHByZXNzdXJlJTIwd2FzaGluZyUyMHdpbmRvdyUyMGNsZWFuaW5nfGVufDB8fHx8MTc5MjAxNDkxMXww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "janitorial",
    title: "Janitorial",
    badge: "Commercial Programs",
    description: "Scheduled commercial cleaning and building upkeep programs.",
    span: "md:col-span-6",
    img: "https://images.unsplash.com/photo-1669101602124-f5b78895d91c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHw0fHxjb21tZXJjaWFsJTIwamFuaXRvcmlhbCUyMHNlcnZpY2UlMjBidWlsZGluZyUyMG1haW50ZW5hbmNlJTIwY2xlYW5fZW58MHx8fHwxNzkyMDE0OTA4fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "handyman",
    title: "Handyman",
    badge: "Same-Day Priority",
    description: "Punch lists, mounting, hardware, and everyday fixes done right.",
    span: "md:col-span-6",
    img: "https://images.unsplash.com/photo-1660330590022-9f4ff56b63f6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHw0fHxwbHVtYmluZyUyMGVsZWN0cmljaWFuJTIwcmVwYWlyJTIwaG9tZSUyMG1haW50ZW5hbmNlJTIwd29ya2VyJTIwdHJhZGVzcGVyc29uJTIwcHJvZmVzc2lvbmFsfGVufDB8fHx8MTc5MTg0NTE5N3ww&ixlib=rb-4.1.0&q=85",
  },
];

export const Services = ({ onSelectService }) => {
  return (
    <section id="services" className="py-16 sm:py-24 lg:py-32" data-testid="services-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
        >
          <p className="font-jbmono text-xs sm:text-sm uppercase tracking-[0.25em] text-[#FF2A3B] font-semibold" data-testid="services-eyebrow">
            ✦ Service Matrix
          </p>
          <h2 className="mt-4 font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight" data-testid="services-heading">
            Every trade. One point of contact.
          </h2>
          <p className="mt-4 max-w-2xl text-base sm:text-lg text-slate-400 leading-relaxed">
            Eight core trades for homes, rentals, and commercial spaces — booked
            once, coordinated for you.
          </p>
          <p className="mt-5 inline-block rounded-lg border border-white/10 bg-[#12141C] px-4 py-3 font-jbmono text-xs uppercase tracking-[0.15em] text-slate-300" data-testid="services-licensing-note">
            Work is completed by qualified trade professionals, with licensed professionals used where required.
          </p>
        </motion.div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-12 gap-6 md:[grid-auto-rows:230px]" data-testid="services-bento-grid">
          {SERVICES.map((s, i) => (
            <motion.button
              key={s.id}
              onClick={() => {
                onSelectService(s.id);
                scrollToId("#booking");
              }}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.65, delay: (i % 3) * 0.08, ease: [0.16, 1, 0.3, 1] }}
              className={`group relative min-h-[240px] md:min-h-0 overflow-hidden rounded-xl border border-white/10 text-left ${s.span}`}
              data-testid={`service-card-${s.id}`}
            >
              <img
                src={s.img}
                alt={s.title}
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover opacity-50 transition-all duration-700 group-hover:scale-105 group-hover:opacity-65"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0B0E] via-[#0A0B0E]/55 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-6">
                <span className="inline-block rounded-full border border-[#FF2A3B]/40 bg-[#FF2A3B]/10 px-3 py-1 font-jbmono text-xs uppercase tracking-[0.18em] text-[#FF2A3B]">
                  {s.badge}
                </span>
                <h3 className="mt-3 font-display text-lg sm:text-xl font-bold tracking-tight text-white">
                  {s.title}
                </h3>
                <p className="mt-2 max-w-md text-sm text-slate-400 leading-relaxed">
                  {s.description}
                </p>
                <span className="mt-4 inline-flex items-center gap-1.5 font-jbmono text-xs uppercase tracking-[0.18em] text-slate-300 transition-colors group-hover:text-[#FF2A3B]">
                  Book this service
                  <ArrowUpRight size={14} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </span>
              </div>
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
};
